const PromoActionTypes = {
  SET_PROMO_INPUT_VALUE: "SET_PROMO_INPUT_VALUE",
  THROW_ERROR: "THROW_ERROR",
  CLEAR_ERROR: "CLEAR_ERROR",
  REMOVE_PROMO: "REMOVE_PROMO",
  FETCH_PROMOS_START: "FETCH_PROMOS_START",
  FETCH_PROMOS_SUCCESS: "FETCH_PROMOS_SUCCESS",
  FETCH_PROMOS_FAILURE: "FETCH_PROMOS_FAILURE",
  VALIDATE_PROMO_START: "VALIDATE_PROMO_START",
  VALIDATE_PROMO_SUCCESS: "VALIDATE_PROMO_SUCCESS",
  VALIDATE_PROMO_FAILURE: "VALIDATE_PROMO_FAILURE",
};

export default PromoActionTypes;
